import React from "react";
import "../styles/navigation.css"; // Import the new CSS file

const TopBar = () => {
  return (
    <div className="top-bar">
      <h1>Ridekeluh</h1>
    </div>
  );
};

export default TopBar;
